import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import msbWhite from '../assets/images/logos/msb-white.png';
import googlePlay from '../assets/images/icons/google-play.svg';
import appStore from '../assets/images/icons/app-store-ios.svg';
import HomeSectionLink from './HomeSectionLink';
import { getSocialMedia } from '../services/socialMediaService';

const Footer = () => {
    const [socialLinks, setSocialLinks] = useState([]);

    useEffect(() => {
        const fetchSocials = async () => {
            try {
                const result = await getSocialMedia();
                if (result && (result.data || Array.isArray(result))) {
                    const data = result.data || result;
                    const activeSocials = (Array.isArray(data) ? data : [data]);
                    setSocialLinks(activeSocials);
                }
            } catch (error) {
                console.error("Error loading social media links:", error);
            }
        };
        fetchSocials();
    }, []);

    const renderSocialIcons = () => {
        if (socialLinks && socialLinks.length > 0) {
            return socialLinks.map((social, index) => (
                <li className="mr-3" key={index}>
                    <a href={social.social_link} target="_blank" rel="noreferrer">
                        <i className={social.social_icon}></i>
                    </a>
                </li>
            ));
        }

        return null;
    };

    return (
        <footer id="site-footer" className=" bg-black padding_top">
            <div className="container">
                <div className="row">
                    <div className="col-lg-3 col-md-6 col-sm-6">
                        <div className="footer_panel padding_bottom_half bottom20">
                            <Link to="/" className="footer_logo bottom25">
                                <img src={msbWhite} alt="myskoolbus" />
                            </Link>
                            <p className="whitecolor bottom25">myskoolbus is a very useful mobile app to track the current whereabouts of the bus and get real-time updates. </p>
                            <ul className="social-icons white wow fadeInUp" data-wow-delay="300ms">
                                {renderSocialIcons()}
                            </ul>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                        <div className="footer_panel padding_bottom_half bottom20 pl-0 pl-lg-5">
                            <h3 className="whitecolor bottom25">Navigation</h3>
                            <div className="menu-footer-nav-container">
                                <ul id="menu-footer-nav" className="links">
                                    <li id="menu-item-24"><HomeSectionLink section="header">Home</HomeSectionLink></li>
                                    <li id="menu-item-25"><HomeSectionLink section="about">About Us</HomeSectionLink></li>
                                    <li id="menu-item-26"><Link to="/contact-us">Contact Us</Link></li>
                                    <li id="menu-item-27"><Link to="/parents">msb for Parents</Link></li>
                                    <li id="menu-item-28"><Link to="/schools">msb for Schools</Link></li>
                                    <li id="menu-item-29"><Link to="/packages">Packages</Link></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                        <div className="footer_panel padding_bottom_half bottom20">
                            <h3 className="whitecolor bottom25">Sales Contact</h3>
                            <ul className="hours_links whitecolor bottom25">
                                <li><span>Monday-Friday:</span> <span>8AM-5PM (IST)</span></li>
                                <li><span>Phone:</span> <span><a href="tel:+917622888880">+917622888880</a></span></li>
                                <li><span>Email:</span> <span><a href="mailto:sales@tnowindia.in">sales@tnowindia.in</a></span></li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                        <div className="footer_panel padding_bottom_half bottom20">
                            <h3 className="whitecolor bottom25">Customer Support</h3>
                            <ul className="hours_links whitecolor bottom25">
                                <li><span>Monday-Friday:</span> <span>8AM-5PM (IST)</span></li>
                                <li><span>Phone:</span> <span><a href="tel:+918160902071">+918160902071</a></span></li>
                                <li><span>Email:</span> <span><a href="mailto:cs@tnowindia.in">cs@tnowindia.in</a></span></li>
                            </ul>
                            <div className="">
                                <a href="https://play.google.com/store/apps/details?id=com.tracknow.myskoolbus" target="_blank" rel="noreferrer" style={{ marginRight: '30px' }}><img src={googlePlay} width="25px" alt="Google Play" /></a>
                                <a href="https://apps.apple.com/in/app/myskoolbus-pro/id1431829473" target="_blank" rel="noreferrer"><img src={appStore} width="25px" alt="App Store" /></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
